import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import { navigate } from '@reach/router'

import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import './SideNav.css';
import { DEPARTMENT_HEADS } from '../../constants/roles';

const SideNavBar = ({ auth }) => {
  const { user } = auth;
  const iconsStyle = { fontSize: '1.75em', lineHeight: '50px' };
  const [isDepartmentHead, setIsDepartmentHead] = useState(false);

  useEffect(() => setIsDepartmentHead(DEPARTMENT_HEADS.includes(user.role)), [user.role]);

  return (
    <SideNav
          onSelect={(selected) => {
              navigate(`/${selected}`)
          }}
          className="side-bar"
      >
      <SideNav.Toggle />
        { user.role ? (
          <SideNav.Nav>
            <NavItem eventKey="admin/inicio">
              <NavIcon>
                  <i className="fa fa-fw fa-home" style={iconsStyle} />
              </NavIcon>
              <NavText>
                  Inicio
              </NavText>
            </NavItem>
            {isDepartmentHead && (
              <NavItem eventKey="admin/nuevo">
                <NavIcon>
                  <span className="fa-stack fa-fw" style={{...iconsStyle, marginBottom: '0.2em' }}>
                    <i className="fa fa-stack-1x fa-graduation-cap" />
                    <i className="fa fa-stack-1x fa-plus" style={{ fontSize: '0.7em', marginTop: '0.5em', marginLeft: '0.65em' }} />
                  </span>
                </NavIcon>
                <NavText>
                    Registrar alumno
                </NavText>
              </NavItem>
            )}
            {isDepartmentHead && (
              <NavItem eventKey="admin/periodos">
                <NavIcon>
                    <i className="fa fa-fw fa-calendar" style={iconsStyle} />
                </NavIcon>
                <NavText>
                    Listado de periodos
                </NavText>
              </NavItem>
            )}
            </SideNav.Nav>
        ) : (
          <SideNav.Nav>
          <NavItem eventKey="aspirantes/inicio">
            <NavIcon>
                <i className="fa fa-fw fa-home" style={iconsStyle} />
            </NavIcon>
            <NavText>
                Inicio
            </NavText>
          </NavItem>
          </SideNav.Nav>
        )
        
        }
  </SideNav>
  )
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, null)(SideNavBar)